// extracted by mini-css-extract-plugin
module.exports = {"switchTabD":"SwitchTabD_switchTabD__qFuTH"};